let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("loX0P")).then(() => parcelRequire('egGdn'));